module.exports = __webpack_public_path__ + "svg/shape-footer.svg";